import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  Input,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { TermpageService } from '../termpage.service';
import { CommonModule, ViewportScroller } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ContentfulEntry } from '../../../../shared/models/common.interfaces';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-terms-of-service-content',
  templateUrl: './terms-of-service-content.component.html',
  styleUrls: ['./terms-of-service-content.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
  encapsulation: ViewEncapsulation.None,
})
export class TermsOfServiceContentComponent implements OnInit, OnDestroy {
  @Input() pageData: any = null;
  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  termData: any = null;
  selectedItem = 0;
  count = 2;
  openInNewTab = true;
  elementRef: ElementRef;
  fileUrl?: SafeResourceUrl;

  constructor(
    private termpageService: TermpageService,
    private viewportScroller: ViewportScroller,
    elementRef: ElementRef,
    private dom: DomSanitizer
  ) {
    this.subscriptions = [];
    this.elementRef = elementRef;
  }

  ngOnInit(): void {
    if (this.pageData != null) {
      this.termData = this.pageData;
      this.fileUrl = this.dom.bypassSecurityTrustResourceUrl(
        `https:${this.termData?.termsAndConditionsDocument?.fields?.file?.url}#toolbar=0&navpanes=0`
      );
    }
  }

  public onClick(elementId: number): void {
    const id = 'target' + (elementId + 1);
    const dom = this.elementRef.nativeElement as HTMLElement;
    const element = dom.querySelector('#' + id) as HTMLElement;
    if (element) {
      let eleHeight = element.offsetTop;
      eleHeight = parseInt(eleHeight.toString()) - 110;
      this.viewportScroller.scrollToPosition([0, eleHeight]);
    }
  }
}
